import type { AmplitudeApiKey } from "./Platform";

const AMPLITUDE_DEV_KEY = "36f151576fa0e8cdba5b230d789ddac8";
const AMPLITUDE_PROD_KEY = "c6cd519bf8c4dd4eb227e59e3943585c";

/** The Amplitude project for the backend at `origin`: production for `primepoint.ai` and
 *  its subdomains, development anywhere else. The web passes its page origin; the iOS shell
 *  passes its API origin, since its page is served from `capacitor://localhost` whichever
 *  backend it talks to. Exact-or-subdomain, never a bare suffix, so a lookalike host
 *  (`evilprimepoint.ai`) cannot report into production: the same rule as native's
 *  `NativeAnalytics.apiKey(forOrigin:)`. */
export function amplitudeApiKeyForOrigin(origin: string): AmplitudeApiKey {
    let host: string;
    try {
        host = new URL(origin).hostname;
    } catch {
        return AMPLITUDE_DEV_KEY;
    }
    return host === "primepoint.ai" || host.endsWith(".primepoint.ai")
        ? AMPLITUDE_PROD_KEY
        : AMPLITUDE_DEV_KEY;
}
